<page-header style="background-color: #005595"></page-header>
<mat-card>
  <mat-card-content>
    <div class="flex flex-col gap-4">
      <h1>
        <span style="font-size:30px">Search for ORELAP Labs</span>
      </h1>
      <form [formGroup]="form" (keydown.enter)="$event.preventDefault()">
        <div class="flex flex-col gap-4">
          <div class="flex flex-row gap-2">
            <span>Search By:</span>
            <mat-radio-group formControlName="searchParam1">
              <mat-radio-button color="primary" class="p-x-8" value="None" (click)="clearRadio1('None')">
                None</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="LabName" (click)="clearRadio1('LabName')"> Lab
                Name</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="OrelapId" (click)="clearRadio1('OrelapId')"> ORELAP
                ID</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="State" (click)="clearRadio1('State')"> State
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="flex flex-row gap-2">
            <mat-form-field *ngIf="!hideSearch1" class="w-3/10 sm:w-1/2">
              <input matInput placeholder="Search Field" formControlName="search" />
              <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch1()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field *ngIf="!hideStates">
              <mat-label>State</mat-label>
              <mat-select formControlName="search">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let states of stateList" [value]="states.key">{{states.value}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex flex-row gap-2">
            <span>Search Analytes By:</span>
            <mat-radio-group formControlName="searchParam2">
              <mat-radio-button color="primary" class="p-x-8" value="None" (click)="clearRadio2('None')">
                None</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="Analyte" (click)="clearRadio2('Analyte')">
                Analyte</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="AnalyteCode" (click)="clearRadio2('AnalyteCode')">
                Analyte
                Code</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="MethodCode" (click)="clearRadio2('MethodCode')">
                Method
                Code</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="MethodReference"
                (click)="clearRadio2('MethodReference')"> Method
                Reference</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="flex flex-row gap-2" *ngIf="!hideSearch2">
            <mat-form-field class="w-3/10 sm:w-1/2">
              <input matInput placeholder="Search Analytes" formControlName="searchAnalytes">
              <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch2()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div class="flex flex-row gap-2">
            <span>Matrix:</span>
            <mat-checkbox formControlName="dw">Drinking Water</mat-checkbox>
            <mat-checkbox formControlName="np">Non-Potable</mat-checkbox>
            <mat-checkbox formControlName="s">Solids</mat-checkbox>
            <mat-checkbox formControlName="air">Air</mat-checkbox>
            <mat-checkbox formControlName="bt">Biological</mat-checkbox>
          </div>

          <div class="flex flex-col">
            <div class="flex flex-row gap-2">
              <span>Filter:</span>
              <mat-checkbox formControlName="commercial">Accepts Public Samples</mat-checkbox>
              <mat-checkbox formControlName="cannabis"
                title="Cannabis labs are filtered on the analyte code 5405">*Cannabis </mat-checkbox>
              <mat-checkbox formControlName="psilocybin"
                title="Psilocybin labs are filtered on the analyte code 6172">**Psilocybin</mat-checkbox>
            </div>
            <span style="font-size: 8px;">* Cannabis labs are filtered on the analyte code 5405</span>
            <span style="font-size: 8px;">** Psilocybin labs are filtered on the analyte code 6172</span>
            <div>
              <button type="submit" class="m-8" mat-raised-button color="primary" (click)="submitRequest()">Search Labs</button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="flex flex-row">
      <mat-card class="mt-8 w-full sm:w-full" [ngClass]="{
      'bg-gray-700': settings.theme === 'dark',
      'bg-indigo-50': settings.theme === 'light'}">
        <mat-card-content>
          <div class="flex flex-col" *ngIf="list.length !== 0">
            <div class="flex flex-row">
              <mat-form-field class="w-3/10 sm:w-full">
                <input matInput id="labsFilter" (keyup)="filterTable($event.target.value)" placeholder="Filter"
                  value="{{labFilter}}" />

                <button *ngIf="labFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div style="overflow-x:auto">
              <div class="flex flex-row">
                <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                  class="mat-elevation-z8 w-full">
                  <ng-container matColumnDef="labName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                    <td mat-cell *matCellDef="let labs">{{labs.labName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="orelapId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>ORELAP ID</th>
                    <td mat-cell *matCellDef="let labs" style="padding-right:10px;">{{labs.orelapId}}</td>
                  </ng-container>
                  <ng-container matColumnDef="siteAddress">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                    <td mat-cell *matCellDef="let labs" style="padding-right:10px;">{{labs.siteAddress}}</td>
                  </ng-container>
                  <ng-container matColumnDef="siteCity">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
                    <td mat-cell *matCellDef="let labs" style="padding-right:10px;"> {{labs.siteCity}}</td>
                  </ng-container>
                  <ng-container matColumnDef="siteState">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
                    <td mat-cell *matCellDef="let labs">{{labs.siteState}}</td>
                  </ng-container>
                  <ng-container matColumnDef="siteZip">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Zip</th>
                    <td mat-cell *matCellDef="let labs">{{labs.siteZip}}</td>
                  </ng-container>
                  <ng-container matColumnDef="sitePhone">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
                    <td mat-cell *matCellDef="let labs" style="padding-right:10px;">{{labs.sitePhone}}</td>
                  </ng-container>
                  <ng-container matColumnDef="siteEmail">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                    <td mat-cell *matCellDef="let labs" style="padding-right:10px;">{{labs.siteEmail}}</td>
                  </ng-container>
                  <ng-container matColumnDef="accreditation">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Accreditation</th>
                    <td mat-cell *matCellDef="let list">
                      <mat-icon title="Excel" (click)="getExcel(list.appId)">border_all</mat-icon>
                      <mat-icon title="PDF" (click)="getPdf(list.appId)">picture_as_pdf</mat-icon>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
              </div>
            </div>
            <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
            </mat-paginator>
          </div>

        </mat-card-content>

      </mat-card>
    </div>

  </mat-card-content>
</mat-card>